"use strict";
exports.__esModule = true;
exports.TaxType = exports.PriceSourceType = exports.PriceType = void 0;
var PriceType;
(function (PriceType) {
    PriceType["TotalPrice"] = "totalPrice";
    PriceType["DiscountedAmount"] = "discountedAmount";
    PriceType["CrossedOutPrice"] = "crossedOutPrice";
    PriceType["unitPrice"] = "unitPrice";
    PriceType["unitCrossedOutPrice"] = "unitCrossedOutPrice";
    PriceType["OfferCode"] = "offerCode";
})(PriceType = exports.PriceType || (exports.PriceType = {}));
var PriceSourceType;
(function (PriceSourceType) {
    PriceSourceType["Converted"] = "converted";
    PriceSourceType["Original"] = "original";
})(PriceSourceType = exports.PriceSourceType || (exports.PriceSourceType = {}));
var TaxType;
(function (TaxType) {
    TaxType["Included"] = "included";
    TaxType["excluded"] = "excluded";
    TaxType["onSite"] = "onSite";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
//# sourceMappingURL=money.js.map